import React, {useEffect} from "react";

import "../styles/footer.css";

function Footer() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="Footer">
      <span>You can contact EduCare at <a href="mailto:educare.info.ai@gmail.com">educare.info.ai@gmail.com</a></span>
      <div className="line"></div>
      <span>Website Built and Maintained by <a href="https://ignuxas.com/">Ignas Mikolaitis</a></span>
      <div id="Copyright">2024 © educare.ignuxas.com</div>
    </div>
  );
}

/*
        <NavLink className="NavBtn" to="/">Namai</NavLink>
        <NavLink className="NavBtn" to="/produktai">Produktai</NavLink>
        <NavLink className="NavBtn" to="/contact">Užsakymai</NavLink>
        <NavLink className="NavBtn" to="/about">Apie Mus</NavLink>
        <NavLink className="NavBtn" to="/contact">Kontaktuoti</NavLink>
* */

export default Footer;
